<template>
	<v-card>
		<v-card-title>
			<h2>Historia poprawek</h2>
		</v-card-title>
		<v-card-text>
			<CompareProjectVersionsDialog v-if="history.length > 0" :status="project.status"
				:contest-id="project.contestId" :last-version="history.length + 1"/>
			<b>Nazwa projektu:</b> {{project.title}}<br/>
			<b>Nr projektu:</b> {{project.projectCode}}<br/>
			<b>Autor:</b> {{project.bidderName}}
		</v-card-text>

		<v-data-table
			hide-actions
			:headers="tableHeaders"
			:items="history">
			<template slot="items" slot-scope="props">
				<tr style="height: 64px">
					<td>{{ props.item.correctionDate }}</td>
					<td>{{ props.item.correctionCause }}</td>
					<td>{{ props.item.detailedCorrectionCause }}</td>
					<td>
						<v-btn @click="viewVersion(props.item.version)">
							Podgląd
						</v-btn>
					</td>
				</tr>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
	import {Project} from "@/api/generated/Project";
	import CompareProjectVersionsDialog from "./compareComponents/CompareProjectVersionsDialog";

	export default {
		name: "ProjectChangesHistory",
		components: {CompareProjectVersionsDialog},
		data () {
			return {
				project: {
					projectCode: '',
          status: '',
					title: '',
					bidderName: ''
				},
				tableHeaders: [
					{text: "Data", sortable: false, width: "180px"},
					{text: "Powód", sortable: false, width: "260px"},
					{text: "Opis", sortable: false},
					{text: "Podgląd stanu przed poprawką", sortable: false},
				],
				history: []
			};
		},

		methods: {
			refresh () {
				this.loadData();
			},

			viewVersion (version) {
				this.$router.openInNewTab("/view/project/".concat(this.$route.params.projectId).concat("/").concat(version));
			},

			loadData () {
				Project.getPublicBasicData(this, this.$route.params.projectId, success => {
					this.project.projectCode = success.projectCode;
          this.project.status = success.projectStatus;
					this.project.title = success.title;
					this.project.bidderName = success.mainBidder.polishName;
				});
				Project.getCorrectionHistory(this, this.$route.params.projectId, success => {
					success.shift();
					this.history = success;
				});
			}
		},

		created () {
			this.loadData();
		}
	};
</script>

<style scoped>

</style>